(function() {
    'use strict';

    angular.module('process')
        .controller('OrderStopDeliveryController', OrderStopDeliveryController);

    OrderStopDeliveryController.$inject = ['order', '$uibModalInstance', 'orderDataSrvc', 'notificationSrvc', 'orderDeliveryStatusConst', 'orderUpdateMessagesConst', 'errorNotificationSrvc'];

    function OrderStopDeliveryController(order, $uibModalInstance, orderDataSrvc, notificationSrvc, orderDeliveryStatusConst, orderUpdateMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.data = {
            delivery_lock_reason: null,
        };

        self.serverErrors = {
            delivery_lock_reason: [],
            nonFieldErrors: []
        };

        self.ok = ok;
        self.close = close;

        function ok() {
            orderDataSrvc.stopDelivery({
                pk: order.pk,
                delivery_lock_reason: self.data.delivery_lock_reason
            }).$promise.then(
                function(response) {
                    order.delivery_lock_reason = self.data.delivery_lock_reason;
                    order.delivery_status = orderDeliveryStatusConst.stopped.value;
                    order.delivery_status_display = orderDeliveryStatusConst.stopped.title;
                    notificationSrvc.notification("success", orderUpdateMessagesConst.stopped);
                    self.close(response);
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function close(response) {
            $uibModalInstance.close(response);
        }
    }
})();
